import React from "react";
import styled from "styled-components";
import { Box } from "@/components/Atoms";

// redux
import { useAppDispatch, useAppSelector } from "@/hooks";
import {
  setDropdownList,
  setSearchValue,
  openDropdown,
  closeDropdown,
} from "@/redux/FaqsReducer";
import { debounce } from "@/utils";

function SearchBar() {
  const dispatch = useAppDispatch();
  const { searchValue, questionsList } = useAppSelector(
    (state) => state.yogaFaqsReducer
  );

  const handleDropDownList = (userInput: string) => {
    let dropdownList = questionsList.filter(
      ({ question, url }: { question: string; url: string }) => {
        const isMatch = question
          .toLowerCase()
          .includes(userInput.toLowerCase());
        if (isMatch) {
          return {
            question,
            url,
          };
        }
      }
    );

    dropdownList = dropdownList.map(
      ({ question, url }: { question: string; url: string }) => {
        const replaceString = `<span className="matchedText">${userInput}</span>`;
        return {
          question,
          styledQuestion: question.replaceAll(
            new RegExp(userInput, "gi"),
            replaceString
          ),
          url,
        };
      }
    );

    dispatch(
      setDropdownList({
        dropdownList,
      })
    );
    dispatch(openDropdown());
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const userInput = event.target.value;
    dispatch(
      setSearchValue({
        text: userInput,
      })
    );

    if (userInput.length < 3) {
      dispatch(closeDropdown());
    } else {
      debounce(() => handleDropDownList(userInput), 500)();
    }
  };

  return (
    <SearchWrapper>
      <Input
        type="text"
        name="search bar"
        id="faq-search-bar"
        role="search"
        value={searchValue}
        onChange={handleSearch}
        placeholder="Enter your search terms here..."
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
          stroke="#6E55D3"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 21L16.65 16.65"
          stroke="#6E55D3"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SearchWrapper>
  );
}

export default SearchBar;

const SearchWrapper = styled(Box)`
  display: flex;
  width: 600px;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 12px;
  background: #ffffff;
  gap: 10px;

  @media (max-width: 650px) {
    align-self: stretch;
    padding: 16px 16px;
    width: 100%;
  }
`;

const Input = styled.input`
  color: #1d2939;
  font-family: var(--man);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  height: 24px;
  width: 100%;
  border: none;
  outline: none;
  caret-color: #6e55d3;
  &::placeholder {
    color: #98a2b3;
    opacity: 0.7;
  }
`;
